import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import encryption from './encryption'

Vue.use(Vuex)

const viewModes = [
  {
    name: 'note',
    icon: 'sticky-note'
  }, {
    name: 'list',
    icon: 'list'
  }, {
    name: 'mindmap',
    icon: 'project-diagram'
  }]

const defaultViewMode = viewModes.find(m => m.name === 'note')

const state = {
  notes: {},
  contextedPrefix: 'c@',
  user: null,
  initialized: false,
  activeViewMode: null,
  defaultViewMode,
  viewModes,
  sideBarCollapsed: false,
  online: navigator.onLine
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    encryption
  }
})

export default store
